<template>
	<div class="slideshow" @dragstart="startDrag" @dragend="stopDrag" @touchstart.prevent="startDrag" @touchend.prevent="stopDrag" draggable="true">
		<transition name="fade" mode="out-in">
			<lazy-background v-for="(slide, i) in slides" :src="((slide.image)?slide.image.thumbs.thumb1920:null)" class="slide" v-if="index === i" :key="'slide-' + i">
				<div class="content">
					<h1>{{ slide.heading }}</h1>
					<p>{{ slide.description }}</p>
				</div>
			</lazy-background>
		</transition>
	</div>
</template>

<script>
	export default {
		props: ['slides', 'id', 'template'],
		data() {
			return {
				index: 0,
				timeout: null,
				startX: 0
			};
		},
		methods: {
			startDrag(event) {
				if(event.dataTransfer) {
					const div = document.createElement('div');
					event.dataTransfer.setDragImage(div, 0, 0);
				}
				clearTimeout(this.timeout);
				this.startX = ((event.changedTouches)?event.changedTouches[0].clientX:event.clientX);
			},
			stopDrag(event) {
				if(((event.changedTouches)?event.changedTouches[0].clientX:event.clientX) - this.startX < -100) {
					this.nextSlide();
				}
				if(((event.changedTouches)?event.changedTouches[0].clientX:event.clientX) - this.startX > 100) {
					this.previousSlide();
				}
			},
			nextSlide() {
				this.doTimeout();
				this.index++;
				if(this.index > this.slides.length - 1) {
					this.index = 0;
				}
			},
			previousSlide() {
				this.doTimeout();
				this.index--;
				if(this.index < 0) {
					this.index = this.slides.length - 1;
				}
			},
			doTimeout() {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(this.nextSlide.bind(this), 5000);
			}
		},
		created() {
			if(typeof(window) === 'undefined') {
				return;
			}
			this.timeout = setTimeout(this.nextSlide.bind(this), 5000);
		},
		destroyed() {
			clearTimeout(this.timeout);
			this.timeout = null;
		}
	}
</script>